// extracted by mini-css-extract-plugin
export default {"ccUpdateButtons":"injectedForm__ccUpdateButtons__Jlksz"};